import * as React from 'react';
import classnames from 'classnames';

const LineItemQuantity = ({ quantity , className  })=>{
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames('line-item-quantity', className)
    }, quantity);
};

export { LineItemQuantity as default };
//# sourceMappingURL=LineItemQuantity.js.map
